export default __webpack_public_path__ + "static/media/red-2.ca8f3ca3.svg";